const BLOCKING_OVERLAYS = 'ion-modal, ion-alert, ion-action-sheet, ion-popover, ion-loading, ion-picker-legacy';

/** Inline Ionic overlays stay mounted after dismissal. Only a presented (or
 * opening) overlay owns Android Back; a cached closed modal must not swallow it. */
export function hasPresentedOverlay(root: Pick<Document, 'querySelectorAll'> = document): boolean {
  return Array.from(root.querySelectorAll(BLOCKING_OVERLAYS)).some((element) => {
    const overlay = element as HTMLElement & { isOpen?: boolean; overlayIndex?: number };
    return overlay.isOpen === true
      || ((overlay.overlayIndex ?? 0) > 0 && !overlay.classList.contains('overlay-hidden'));
  });
}
